import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = {
  key: 0,
  version: "1.1",
  id: "loader-1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "20px",
  height: "20px",
  viewBox: "0 0 50 50",
  style: {"enable-background":"new 0 0 50 50"},
  "xml:space": "preserve"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
}, [
  /*#__PURE__*/_createElementVNode("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "rotate",
    from: "0 25 25",
    to: "360 25 25",
    dur: "0.6s",
    repeatCount: "indefinite"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: _ctx.type,
    class: _normalizeClass(['btn btn-primary', _ctx.fullWidth && 'd-block w-100']),
    disabled: _ctx.disabled,
    style: _normalizeStyle([
      _ctx.disabled &&
        _ctx.borderedDisabled && { borderColor: 'var(--bs-secondary) !important' },
    ])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
  ], 14, _hoisted_1))
}